import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { fetchAppToken } from '../actions/token'
import Toastr from './components/toastr';
import { Button, Form, Grid, Header, Segment, Divider } from 'semantic-ui-react'
import '../App.css';
import SystemHeader from './components/system_header'
import { clearNamespace } from '../store';

class Login extends Component {
  constructor(props){
    super(props);

    this.state = {
      username: '',
      password: '',
      messageShown: true,
      message:  "Invalid email or password. Please try again."
    }

    this.messageTimer = null;
  }

  dismissMessage() {
    this.setState({
      messageShown: false
    })
  }

  showMessage() {
    clearTimeout(this.messageTimer);
    this.messageTimer = setTimeout(() => {
      this.dismissMessage();
    }, 6000);

    if (this.state.messageShown && this.props.loginFailure) {
      return <Toastr messageBody={this.state.message} messageType="red" dismiss={ this.dismissMessage.bind(this) }/>
    }
    return null;
  }

  componentDidMount(){
    clearNamespace();
  }

  //Set the messageShown state to TRUE before the props are updated
  componentWillReceiveProps(nextProps){
    this.setState({
      messageShown: true
    })
  }

  render(props) {
    return (
      <div className="login-page">
        <SystemHeader
          showMenu={false}
          showLoading={false}
        />
        <div className='login-form'>
          { this.props.loginFailure && this.showMessage() }
          <Grid
            textAlign='center'
            style={{ height: '100%' }}
            verticalAlign='middle'
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as='h2' color='teal' textAlign='center'>
                Log-in to your account
              </Header>
              <Form size='large'>
                <Segment>
                  <Form.Input
                    fluid
                    icon='user'
                    iconPosition='left'
                    placeholder='E-mail address'
                    type='username'
                    defaultValue={this.state.username}
                    onChange={event => this.setState({username: event.target.value})}
                  />
                  <Form.Input
                    fluid
                    icon='lock'
                    iconPosition='left'
                    placeholder='Password'
                    type='password'
                    defaultValue={this.state.password}
                    onChange={event => this.setState({password: event.target.value})}
                  />
                  <Button loading={this.props.pending} color='teal' fluid size='large' onClick={() => this.props.login(this.state)}>Login</Button>
                  <Divider />
                  <Link to='/password_reset'>Forgot Password?</Link>
                </Segment>
              </Form>
            </Grid.Column>
          </Grid>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.token.accessToken,
    loading: state.token.loading,
    loginSuccess: state.token.loginSuccess,
    loginFailure: state.token.loginFailure,
    pending: state.token.pending,
    signedIn: state.token.signedIn,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (localState) => {
      var { username, password, grant_type } = localState;
      dispatch(fetchAppToken({username, password, grant_type }))
    }
  }
}

let LoginPage = connect(mapStateToProps, mapDispatchToProps)(Login)
export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/login.js